import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import './assets/layout/layout.scss';
import 'material-icons/iconfont/material-icons.scss';
import 'material-icons/css/material-icons.scss';

import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Card from 'primevue/card';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Ripple from 'primevue/ripple';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';
import AutoComplete from 'primevue/autocomplete';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Textarea from 'primevue/textarea';
import Paginator from 'primevue/paginator';
import Breadcrumb from 'primevue/breadcrumb';
import MultiSelect from 'primevue/multiselect';
import Chips from 'primevue/chips';
import OverlayPanel from 'primevue/overlaypanel';
import Dialog from 'primevue/dialog';
import SplitButton from 'primevue/splitbutton';
import InputMask from 'primevue/inputmask';
import Tooltip from 'primevue/tooltip';
import ColorPicker from 'primevue/colorpicker';
import InputSwitch from 'primevue/inputswitch';
import Menu from 'primevue/menu';
import Skeleton from 'primevue/skeleton';
import Checkbox from 'primevue/checkbox';
import TreeSelect from 'primevue/treeselect';
import RadioButton from 'primevue/radiobutton';
import PrimeVue from 'primevue/config';

const config = {
    locale: {
        firstDayOfWeek: 0,
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        today: 'Hoje',
        clear: 'Limpar',
        dateFormat: 'dd/mm/yy',
        weekHeader: 'Sem',
    },
};

export default function (app) {
    app.config.globalProperties.$primevue = { ripple: true };

    // Config
    app.use(PrimeVue, config);

    // Serviços
    app.use(ToastService);

    // Diretivas
    app.directive('ripple', Ripple);
    app.directive('tooltip', Tooltip);

    // Componentes
    app.component('InputText', InputText);
    app.component('Button', Button);
    app.component('Toast', Toast);
    app.component('Card', Card);
    app.component('Dropdown', Dropdown);
    app.component('Calendar', Calendar);
    app.component('InputNumber', InputNumber);
    app.component('AutoComplete', AutoComplete);
    app.component('DataTable', DataTable);
    app.component('Column', Column);
    app.component('Textarea', Textarea);
    app.component('Paginator', Paginator);
    app.component('Breadcrumb', Breadcrumb);
    app.component('MultiSelect', MultiSelect);
    app.component('Chips', Chips);
    app.component('OverlayPanel', OverlayPanel);
    app.component('Dialog', Dialog);
    app.component('SplitButton', SplitButton);
    app.component('InputMask', InputMask);
    app.component('ColorPicker', ColorPicker);
    app.component('InputSwitch', InputSwitch);
    app.component('Menu', Menu);
    app.component('Skeleton', Skeleton);
    app.component('Checkbox', Checkbox);
    app.component('TreeSelect', TreeSelect);
    app.component('RadioButton', RadioButton);
}
